import Title from "../Title";
import Typo from "../Typo";
import HeroVideo from "../HeroVideo";

export default function SectionConceptHeader({title, body, className, ...rest}) {
    return (
        <HeroVideo size="medium" {...rest}>
            <div className={`flex flex-col gap-4 ${className ? className : 'max-w-[22rem]'}`}>
                <header>
                    <Title Elem="h1">{title}</Title>
                </header>
                <Typo>
                        <span className="md:hidden">
                            {body.mobile}
                        </span>
                    <span className="hidden md:inline">
                            {body.desktop}
                        </span>
                </Typo>
            </div>
        </HeroVideo>
    );
}
